<template>
  <div class="animated fadeIn">
    <div class="card">
      <div class="card-header">
        <span v-if="mData.viewMode == 'create'">{{aLang.c_create}} cấu hình</span>
        <span v-if="mData.viewMode == 'update'">{{aLang.c_update}} cấu hình</span>
        <span v-if="mData.viewMode == 'detail'">{{aLang.c_detail}} cấu hình</span>
        <div class="card-header-actions"></div>
      </div>
      <div class="card-body">
        <el-form
          :model="mData.dataForm"
          :rules="mData.validForm"
          ref="myForm"
          label-width="100%"
          label-position="top"
        >          

          <b-row>
            <b-col md="4">
              <el-form-item label="Mã cấu hình" prop="code">
                <el-input
                  type="text"
                  v-model="mData.dataForm.code"
                  :disabled="mData.viewMode == 'detail'||mData.viewMode == 'update'"
                  clearable
                ></el-input>
              </el-form-item>             
            </b-col>     
            <b-col md="4">
              <el-form-item label="Các quyền được xem" prop="roles">
                <el-select
                  v-model="mData.dataForm.roles"
                  :placeholder="aLang.c_select"
                  :disabled="mData.viewMode == 'detail'"
                  multiple
                  clearable
                  filterable
                >
                  <el-option
                    v-for="item in mData.dataDefault.listQuyen"
                    :key="item.code"
                    :label="item.code"
                    :value="item.code"
                  ></el-option>
                </el-select>            
              </el-form-item>
            </b-col>
            <b-col md="4">
              <el-form-item label="Giá trị" prop="value">
                <el-input
                  type="text"
                  v-model="mData.dataForm.value"
                  :disabled="mData.viewMode == 'detail'"
                  clearable
                ></el-input>
              </el-form-item>           
            </b-col>   
          </b-row>              

          <el-form-item class="text-center mt-3">
            <el-button
              type="info"
              plain
              @click="fn_submitForm('create')"
              v-ladda
              v-if="mData.viewMode == 'create'"
            >{{aLang.c_create}}</el-button>

            <el-button
              type="info"
              plain
              @click="fn_submitForm('update')"
              v-ladda
              v-if="mData.viewMode == 'update'"
            >{{aLang.c_update}}</el-button>

            <el-button @click="fn_go()" type="info" plain>{{aLang.c_back}}</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import LanguageService from "../../../service/LanguageService";
import DataService from "../../../service/DataService";
import MethodService from "../../../service/MethodService";
import CauHinhModel from "./CauHinhModel";
import CauHinhApi from "../../../moduleApi/CauHinhApi";

export default {
  data() {
    return {
      aLang: LanguageService.lang,
      aElement: MethodService.element,
      mData: {
        viewMode: "create",
        moduleName: "CauHinh",
        dataDefault: {
          roles: DataService.rolesInForm,
          listQuyen: DataService.accountRoles    
        },
        dataForm: MethodService.copyObject(CauHinhModel.dataForm),
        validForm: CauHinhModel.validForm,
        dialog: {}        
      }
    };
  },
  methods: {
    fn_submitForm(type) {
      this.$refs["myForm"].validate(async valid => {
        if (valid) {
          if (type == "create") {             
            await CauHinhApi.create(this.mData.dataForm);
            this.fn_resetForm();
          }
          if (type == "update") {
            this.mData.dataForm.id = this.$router.currentRoute.params.id;
            await CauHinhApi.update(this.mData.dataForm);
            this.fn_go(-1);
          }
        } else {
          MethodService.stopLadda();
          return false;
        }
      });
    },
    fn_resetForm() {
      this.$refs["myForm"].resetFields();
    },
    fn_go() {
      this.$router.go(-1);
    },
    async fn_getDataById(id) {
      let res = await CauHinhApi.findById(id);
      this.mData.dataForm = res.result;      
    },
    async fn_initDataDefault() {    

    },   
  },
  created: function() { 
    this.fn_initDataDefault();
    if (
      this.$router.currentRoute.name ==
      "Admin-" + this.mData.moduleName + "-update"
    ) {
      this.mData.viewMode = "update";
    }
    if (
      this.$router.currentRoute.name ==
      "Admin-" + this.mData.moduleName + "-detail"
    ) {
      this.mData.viewMode = "detail";
    }
    if (this.$router.currentRoute.params.id) {
      this.fn_getDataById(this.$router.currentRoute.params.id);
    }
  },
  mounted: function() {}
};
</script>